/**
 * handleAuthorized.js
 *
 * Copyright (c) apploft. GmbH
 */

import {authorized} from '../PortalStateSymbol';

export default function handleAuthorized({keyAdminAuth}) {
  return {state: authorized, data: {keyAdminAuth}};
}
